import React from 'react';
import PromptOptionList from './PromptOptionList';
import { cleanPrompts } from '../utils/promptUtils';
import api from '../services/api';

export function PromptSection({ 
  type, 
  projectId, 
  project, 
  specificContext, 
  setSpecificContext,
  selectedPrompt, 
  setSelectedPrompt,
  prompts, 
  setPrompts,
  busy = false 
}) {
  const [fetching, setFetching] = React.useState(false);

  const loadPrompts = async () => {
    if (!project?.context) return;
    
    setFetching(true);
    try {
      const r = await api.composerGeneratePrompts(projectId, { 
        specificContext, 
        type, 
        limit: 4 
      });
      const list = Array.isArray(r?.prompts) ? r.prompts : [];
      const cleaned = cleanPrompts(list);
      setPrompts(cleaned);
      
      if (cleaned.length && !selectedPrompt) {
        setSelectedPrompt(String(cleaned[0].text || ''));
      }
    } finally {
      setFetching(false);
    }
  };

  const btn = (bg) => ({
    background: bg,
    color: '#fff',
    border: 0,
    borderRadius: 8,
    padding: '6px 10px',
    cursor: 'pointer',
    fontSize: 13
  });

  const labels = {
    audio: {
      title: 'Audio Prompts',
      contextLabel: 'Campaign focus or CTA',
      heading: 'Choose an audio prompt'
    },
    image: {
      title: 'Image Prompts', 
      contextLabel: 'Visual emphasis',
      heading: 'Choose an image prompt'
    },
    video: {
      title: 'Video Prompts',
      contextLabel: 'Video narrative focus',
      heading: 'Choose a video prompt'
    }
  };

  const label = labels[type] || labels.video;

  return (
    <div style={{ display: 'grid', gap: 8, background: '#111827', border: '1px solid #1f2937', borderRadius: 10, padding: 12 }}>
      <div style={{ color: '#f9fafb', fontWeight: 600 }}>{label.title}</div>
      <div style={{ display: 'grid', gap: 6 }}>
        <label style={{ color: '#9ca3af', fontSize: 12 }}>Specific Context</label>
        <textarea
          value={specificContext}
          onChange={(e) => setSpecificContext(e.target.value)}
          rows={2}
          placeholder={label.contextLabel}
          style={{ background: '#0f1115', color: '#e5e7eb', border: '1px solid #374151', borderRadius: 6, padding: 8 }}
        />
        <div style={{ display: 'flex', gap: 8 }}>
          <button 
            disabled={fetching} 
            onClick={loadPrompts} 
            style={btn(fetching ? '#4b5563' : '#374151')}
          >
            {fetching ? 'Loading…' : 'Generate Prompts'}
          </button>
          <button 
            disabled={!prompts.length} 
            onClick={() => { setSelectedPrompt(''); loadPrompts(); }} 
            style={btn('#1f2937')}
          >
            Refresh
          </button>
        </div>
      </div>
      <PromptOptionList
        prompts={prompts}
        selectedPrompt={selectedPrompt}
        onSelect={setSelectedPrompt}
        busy={busy}
        heading={label.heading}
        scoreLabel="Score"
      />
    </div>
  );
}
